import Vue from 'vue'
import VueResource from 'vue-resource'

if ($('#login_user').length) {
  Vue.use(VueResource)

  let loginForm = $('#login_user')

  if (loginForm.length > 0) {
    new Vue({
      el: '#login_user',
      data: {
        loading: 0,
        error: '',
        formData: {
          _username: '',
          _password: '',
          roles: {},
        },
        roles : [],
      },
      http: {
        emulateJSON: true,
        emulateHTTP: true
      },
      methods: {
        submitForm() {
          let targetPath = $('#target_path').val()

          this.error = ''
          let url = Routing.generate('fos_user_security_check')

          this.$http.post(url, this.formData).then(response => {
            if (response.body.success) {
              window.location.replace(targetPath ? targetPath : Routing.generate('homepage_admin'))
            }
          }, response => {
            this.error = response.body.message
          })
        },
      }
    })
  }
}
